var _g, _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 325,
    viewBox: "0 0 465 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_d_12129_8436)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -134,
    y: 124,
    width: 279,
    height: 279,
    rx: 139.5,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.4766 130.489C76.5708 75.76 109.252 31.4785 175.658 31.4785C242.063 31.4785 274.839 130.489 274.839 130.489C274.839 130.489 301.811 228.817 375.557 228.817C449.302 228.817 472.74 184.604 473.202 130.489",
    stroke: "#C1F3FF",
    strokeWidth: 2.73132,
    strokeLinejoin: "round",
    strokeDasharray: "8.19 8.19"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 28.7754,
    y: 70.2393,
    width: 120.503,
    height: 120.503
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_12129_8436_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 4,
    x: 32.7754,
    y: 74.2393,
    width: 112.503,
    height: 112.503,
    rx: 56.2516,
    fill: "white",
    fillOpacity: 0.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0281 118.768C86.7103 118.768 84.4446 119.456 82.5174 120.744C80.5902 122.031 79.0881 123.861 78.2011 126.003C77.3141 128.144 77.0821 130.501 77.5342 132.774C77.9864 135.047 79.1026 137.135 80.7415 138.774C82.3804 140.413 84.4686 141.529 86.7419 141.981C89.0151 142.434 91.3714 142.202 93.5128 141.315C95.6542 140.428 97.4845 138.926 98.7722 136.998C100.06 135.071 100.747 132.805 100.747 130.488M91.3719 109.522C87.0266 109.035 82.6373 109.91 78.8109 112.026C74.9846 114.142 71.9105 117.395 70.0138 121.335C68.117 125.274 67.4915 129.706 68.2236 134.017C68.9557 138.328 71.0094 142.305 74.1004 145.397C77.1915 148.49 81.1672 150.545 85.4777 151.28C89.7881 152.014 94.2202 151.391 98.1609 149.496C102.102 147.601 105.356 144.529 107.474 140.703C109.592 136.878 110.469 132.489 109.984 128.144M96.0596 123.456V116.425L103.091 109.393V116.425H110.122L103.091 123.456H96.0596ZM96.0596 123.456L89.0281 130.488M86.6843 130.488C86.6843 131.109 86.9312 131.705 87.3708 132.145C87.8103 132.584 88.4065 132.831 89.0281 132.831C89.6497 132.831 90.2459 132.584 90.6855 132.145C91.125 131.705 91.3719 131.109 91.3719 130.488C91.3719 129.866 91.125 129.27 90.6855 128.83C90.2459 128.391 89.6497 128.144 89.0281 128.144C88.4065 128.144 87.8103 128.391 87.3708 128.83C86.9312 129.27 86.6843 129.866 86.6843 130.488Z",
    stroke: "#2E2F35",
    strokeWidth: 2.63677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 399.721,
    y: 148,
    width: 120.501,
    height: 120.501
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_12129_8436_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 4,
    x: 403.721,
    y: 152,
    width: 112.501,
    height: 112.501,
    rx: 56.2506,
    fill: "white",
    fillOpacity: 0.68
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450.596 196.532V191.845C450.596 190.602 451.09 189.409 451.969 188.53C452.848 187.651 454.04 187.157 455.283 187.157H464.658C465.902 187.157 467.094 187.651 467.973 188.53C468.852 189.409 469.346 190.602 469.346 191.845V196.532M459.971 208.251V208.275M438.877 210.595C445.42 213.892 452.644 215.609 459.971 215.609C467.298 215.609 474.522 213.892 481.065 210.595M438.877 201.22C438.877 199.977 439.371 198.784 440.25 197.905C441.129 197.026 442.321 196.532 443.565 196.532H476.377C477.621 196.532 478.813 197.026 479.692 197.905C480.571 198.784 481.065 199.977 481.065 201.22V222.314C481.065 223.557 480.571 224.749 479.692 225.628C478.813 226.508 477.621 227.001 476.377 227.001H443.565C442.321 227.001 441.129 226.508 440.25 225.628C439.371 224.749 438.877 223.557 438.877 222.314V201.22Z",
    stroke: "#2E2F35",
    strokeWidth: 2.63673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 230.25,
    y: 98.9902,
    width: 88.5327,
    height: 96.3496
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_2_12129_8436_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M267.017 105C271.658 102.321 277.376 102.321 282.017 105L307.283 119.587C311.924 122.267 314.783 127.219 314.783 132.578V161.753C314.783 167.112 311.924 172.064 307.283 174.743L282.017 189.331C277.376 192.01 271.658 192.01 267.017 189.331L241.751 174.743C237.11 172.064 234.251 167.112 234.251 161.753V132.578C234.251 127.219 237.11 122.267 241.751 119.587L267.017 105Z",
    fill: "white",
    fillOpacity: 0.68
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.067 165.856H260.046C258.125 165.856 256.826 163.888 257.578 162.113L264.136 146.613C264.295 146.165 264.281 145.908 264.281 145.908H267.871C267.867 146.215 267.815 146.421 267.68 146.745L261.317 161.834C261.174 162.172 261.422 162.547 261.787 162.547H266.63C267.604 162.547 268.483 161.963 268.864 161.064L278.384 138.571C279.923 134.936 285.054 134.927 286.606 138.556L287.284 140.141L285.432 144.306L284.128 141.247C283.508 139.794 281.453 139.797 280.838 141.252L271.359 163.669C270.799 164.995 269.502 165.856 268.067 165.856Z",
    fill: "url(#paint0_radial_12129_8436)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.067 125.975H260.046C258.125 125.975 256.826 127.943 257.578 129.718L264.136 145.217C264.295 145.666 264.281 145.922 264.281 145.922H267.871C267.867 145.616 267.815 145.41 267.68 145.086L261.317 129.996C261.174 129.658 261.422 129.284 261.787 129.284H266.63C267.604 129.284 268.483 129.868 268.864 130.767L274.514 144.115L276.317 139.886L271.359 128.161C270.799 126.836 269.502 125.975 268.067 125.975Z",
    fill: "url(#paint1_radial_12129_8436)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.088 151.542L279.658 147.78L280.859 150.586C281.472 152.022 283.503 152.035 284.141 150.599L290.144 136.938C290.272 136.656 290.642 136.63 290.808 136.873L292.507 139.424C292.584 139.526 292.596 139.667 292.545 139.795L286.849 152.932C285.253 156.61 280.016 156.495 278.586 152.752L278.088 151.542Z",
    fill: "#8952E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290.641 147.921L288.828 152.15L290.348 155.956C290.476 156.264 290.897 156.277 291.05 155.969L292.583 152.791C292.634 152.688 292.634 152.573 292.583 152.47L290.641 147.921Z",
    fill: "#2DD1DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12129_8436",
    x: -194,
    y: 84,
    width: 399,
    height: 399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.301961 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12129_8436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12129_8436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_12129_8436_clip_path",
    transform: "translate(-28.7754 -70.2393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.7754,
    y: 74.2393,
    width: 112.503,
    height: 112.503,
    rx: 56.2516
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_12129_8436_clip_path",
    transform: "translate(-399.721 -148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.721,
    y: 152,
    width: 112.501,
    height: 112.501,
    rx: 56.2506
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_12129_8436_clip_path",
    transform: "translate(-230.25 -98.9902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.017 105C271.658 102.321 277.376 102.321 282.017 105L307.283 119.587C311.924 122.267 314.783 127.219 314.783 132.578V161.753C314.783 167.112 311.924 172.064 307.283 174.743L282.017 189.331C277.376 192.01 271.658 192.01 267.017 189.331L241.751 174.743C237.11 172.064 234.251 167.112 234.251 161.753V132.578C234.251 127.219 237.11 122.267 241.751 119.587L267.017 105Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12129_8436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.9155 17.8421 -7.80786 -3.19923 268.443 144.328)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7174DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#7170DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD1DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12129_8436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.97706 4.86833 -6.02104 13.1919 275.199 127.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7172DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#736FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8952E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.9c1cbfa0feb895977d11b6e4106ddb94.svg";
export { ForwardRef as ReactComponent };